// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dynamic-attributes-modal .modal-dialog {\n  max-width: 100%;\n}\n.dynamic-attributes-modal .modal-footer {\n  border: none;\n  padding: 0\n}\n@media (min-width: 768px) {\n.dynamic-attributes-modal .modal-dialog {\n    max-width: 80%\n}\n}\n@media (min-width: 1024px) {\n.dynamic-attributes-modal .modal-dialog {\n    max-width: 60%\n}\n}\n\n", ""]);
// Exports
module.exports = exports;
